module.exports = __webpack_public_path__ + "img/arrow-down.523ec7be.svg";